import p_img1 from './product1.png'
// import p_img2 from './product2.png'
import p_img3 from './product3.png'
import p_img4 from './product4.png'
import p_img5 from './product5.png'
import p_img6 from './product6.png'
import p_img7 from './product7.png'
import p_img8 from './product8.png'
import p_img9 from './product9.png'
import p_img10 from './product10.png'
import single_img1 from './banner9.png'
import single_img2 from './banner-random.png'



import logo from './logo.png'
import flag from './indian-flag.png'
import cart from './cart.png'
import user from './user.png'
import menu_icon from './menu_icon.png'
import dropdown_icon from './dropdown_icon.png'
import banner_01 from './banner1.png'
import banner_02 from './banner02.jpg'
import banner_03 from './banner-third.jpg'
import youtube_icon from './youtube.png'
import donate_icon from './worth-donation.png'
import mic_icon from './successful-campaings.png'
import noun_icon from './noun-donation.png'
import unique_icon from './unique-donors.png'
import footer_logo from './footer-logo.png'
import dog_img1 from './whydonate1.png'
import dog_img2 from './whydonate2.png'
import brand_img1 from './brand-1.png'
import brand_img2 from './brand-2.png'
import brand_img3 from './brand-3.png'
import brand_img4 from './brand-4.png'
import brand_img5 from './brand-5.png'
import testimonial_user1 from './testimonial01.png'
import testimonial_user2 from './testimonial02.png'
import testimonial_user3 from './testimonial03.png'
import explore_banner_img from './banner-right-image-campion.png'
import filter_animal_icon from './animal.png'
import filter_life_event_icon from './life_event.png'
import filter_children_icon from './child.png'
import filter_education_icon from './education.png'
import filter_humger_icon from './hunger.png'
import filter_nature_icon from './nature.png'
import filter_urgent_icon from './urgent.png'
import filter_medical_icon from './medical.png'
import all_products_icon from './all-products-02.png'
import monthly_banner from './banner-monthly.jpg'
import trusted_icon1 from './calandar.png'
import trusted_icon2 from './tax.png'
import trusted_icon3 from './trust.png'
import trusted_icon4 from './partners.png'
import trusted_icon5 from './benefit.png'
import about_banner_img from './banner-about.png'
import ceo_img from './ceo-img.png'
import value_icon1 from './collaborate.png'
import value_icon2 from './love.png'
import value_icon3 from './focus.png'
import value_icon4 from './handshake.png'
import team_img1 from './team-img01.png'
import team_img2 from './team-img02.png'
import legal_img1 from './finalcial-img1.png'
import legal_img2 from './finalcial-img2.png'
import dog_img01 from './dog01.png'
import dog_img02 from './dog02.png'
import dog_img03 from './dog-merge.png'
import login_img from './login-bg.png'
import sign_up from './register-bg.png'
import account_donate_icon from './accout-donate-icon.png'
import account_certificate_icon from './accout-certification.png'
import account_support_icon from './accout-support.png'
import account_volunteer_icon from './volunteer.png'
import account_profile_icon from './profile.png'
import account_faq_icon from './faq.png'
import account_share_icon from './share.png'
import cake_img from './random-cake.png'
import bookmark_icon from './heart1.png'
import calender_icon from './calandar3.png'
import volunteer_banner from './volunteer.jpg'
import product_box_img from './product-demo-produt.png'
import close_icon from './close2.png'
import user_img from './account-img.png'




export const assets = {
    logo,
    flag,
    cart,
    user,
    menu_icon,
    dropdown_icon,
    banner_01,
    banner_02,
    banner_03,
    youtube_icon,
    donate_icon,
    mic_icon,
    noun_icon,
    unique_icon,
    footer_logo,
    dog_img1,
    dog_img2,
    brand_img1,
    brand_img2,
    brand_img3,
    brand_img4,
    brand_img5,
    testimonial_user1,
    testimonial_user2,
    testimonial_user3,
    explore_banner_img,
    filter_animal_icon,
    filter_life_event_icon,
    filter_children_icon,
    filter_education_icon,
    filter_humger_icon,
    filter_nature_icon,
    filter_urgent_icon,
    filter_medical_icon,
    all_products_icon,
    monthly_banner,
    trusted_icon1,
    trusted_icon2,
    trusted_icon3,
    trusted_icon4,
    trusted_icon5,
    about_banner_img,
    ceo_img,
    value_icon1,
    value_icon2,
    value_icon3,
    value_icon4,
    team_img1,
    team_img2,
    legal_img1,
    legal_img2,
    single_img1,
    single_img2,
    dog_img01,
    dog_img02,
    dog_img03,
    login_img,
    sign_up,
    account_donate_icon,
    account_certificate_icon,
    account_support_icon,
    account_volunteer_icon,
    account_profile_icon,
    account_faq_icon,
    account_share_icon,
    cake_img,
    bookmark_icon,
    calender_icon,
  volunteer_banner,
  product_box_img,
  close_icon,
user_img,

}


export const products = [
  
     
    {
        "id": 'aaa',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img1],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "event",
        "target": {
          "goal": 15000,
          "left": 12210
        },

        "isTaxBenefit": true,
         "type": "one-time",
        "subcategories": [ // Subcategories under the main product
      {
        "subId": 'sub1',
        "name": "Food Packets (20 Kids)",
        "videoLink": "https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg",
        "price": 600,
        "description": "Sponsor quality food for rescued dogs."
      },
      {
        "subId": 'sub2',
        "name": "Dog Adoption Support",
        "videoLink": "https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg",
        "price": 450,
        "description": "Help with adoption fees for rescued dogs."
      }
    ],
       
  
      },
      
    
      {
        "id": 'aca',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img3],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [dog_img01, dog_img02, dog_img03], // Gallery 2
        "category": "urgent",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "one-time",
      },
      {
        "id": 'ada',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img4],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "medicine",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
        "type": "one-time"
      },
      {
        "id": 'aeaw',
        "title": "Urgent",
        "image": [p_img5],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "education",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "monthly",
         "subcategories": [ // Subcategories under the main product
      {
        "subId": 'sub1',
        "name": "Food Packets (20 Kids)",
        "videoLink": "https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg",
        "price": 600,
        "description": "Sponsor quality food for rescued dogs."
      },
      {
        "subId": 'sub2',
        "name": "Dog Adoption Support",
        "videoLink": "https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg",
        "price": 450,
        "description": "Help with adoption fees for rescued dogs."
      }
    ],
      },
      {
        "id": 'afa',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img6],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "animals",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "one-time"
      },
      {
        "id": 'aga',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img7],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "nature",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "one-time"
      },
      {
        "id": 'aha',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img8],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "children",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "one-time"
      },
      {
        "id": 'aia',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img9],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "nature",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "monthly"
      },
      {
        "id": 'aja',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img10],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "hunger",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "one-time"
      },
      {
        "id": 'aja',
        "title": "Become a dog’s bestfriend by sponsoring dog food to feed them",
        "image": [p_img10],
        "hoursLeft": 5,
        "sponsors": 524,
        "bannerImg": [single_img1, single_img2], // Gallery 1
        "Contributionimg": [p_img4, p_img5], // Gallery 2
        "category": "hunger",
        "target": {
          "goal": 15000,
          "left": 12210
        },
        "isTaxBenefit": true,
         "type": "monthly"
      }
]